import { cuverseApi } from 'store/api/cuverse-api/cuverse.api';

import { InvoicePdfLinksRoute } from './invoice-pdf-links.route';

export const requestInvoicePdfLink = async (orderId: number): Promise<unknown> =>
  cuverseApi.get(InvoicePdfLinksRoute.InvoicePdfLink(orderId)).then((res) => res?.data);
